export default __webpack_public_path__ + "static/media/footer-logo-mobile.4be21992.svg";